module.exports = __webpack_public_path__ + "img/Mp3.99d20716.svg";